/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function TableInsertRow({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M.775 2.875a2.6 2.6 0 0 1 2.6-2.6h9a2.6 2.6 0 0 1 2.6 2.6v5.5a.6.6 0 1 1-1.2 0v-.9h-11.8v.9a.6.6 0 1 1-1.2 0zm1.2 3.4h11.8v-3.4a1.4 1.4 0 0 0-1.4-1.4h-9a1.4 1.4 0 0 0-1.4 1.4z" clipRule="evenodd" /><path fill="currentColor" d="M4.775 12.625a.6.6 0 0 0 .6.6h1.9v1.9a.6.6 0 1 0 1.2 0v-1.9h1.9a.6.6 0 1 0 0-1.2h-1.9v-1.9a.6.6 0 0 0-1.2 0v1.9h-1.9a.6.6 0 0 0-.6.6M1.375 10.025a.6.6 0 0 0-.6.6v1a1.6 1.6 0 0 0 1.6 1.6h.5a.6.6 0 1 0 0-1.2h-.5a.4.4 0 0 1-.4-.4v-1a.6.6 0 0 0-.6-.6M12.875 13.225a.6.6 0 0 1 0-1.2h.5a.4.4 0 0 0 .4-.4v-1a.6.6 0 0 1 1.2 0v1a1.6 1.6 0 0 1-1.6 1.6z" /></svg>;
}
;